'use strict';

var trust = function ($sce) {
  return function (htmlCode) {
    return $sce.trustAsHtml(htmlCode);
  };
};

module.exports = trust;
